import { render } from "./Button.vue?vue&type=template&id=f18738aa&scoped=true&bindings={}"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=f18738aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f18738aa"

export default script